module.exports = __webpack_public_path__ + "img/vegetarianas.d5aae9ea.jpg";